import React from 'react';

export const CloseCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 21"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3334 10.4944C18.3334 15.0969 14.6025 18.8277 10 18.8277C5.39752 18.8277 1.66669 15.0969 1.66669 10.4944C1.66669 5.89191 5.39752 2.16107 10 2.16107C14.6025 2.16107 18.3334 5.89191 18.3334 10.4944ZM7.47502 7.96941C7.59221 7.85236 7.75106 7.78662 7.91669 7.78662C8.08231 7.78662 8.24117 7.85236 8.35835 7.96941L10 9.61107L11.6417 7.96941C11.7602 7.85901 11.9169 7.7989 12.0788 7.80176C12.2407 7.80462 12.3952 7.87021 12.5097 7.98472C12.6242 8.09923 12.6898 8.25372 12.6927 8.41564C12.6955 8.57755 12.6354 8.73426 12.525 8.85274L10.8834 10.4944L12.525 12.1361C12.6354 12.2546 12.6955 12.4113 12.6927 12.5732C12.6898 12.7351 12.6242 12.8896 12.5097 13.0041C12.3952 13.1186 12.2407 13.1842 12.0788 13.1871C11.9169 13.1899 11.7602 13.1298 11.6417 13.0194L10 11.3777L8.35835 13.0194C8.23987 13.1298 8.08317 13.1899 7.92125 13.1871C7.75933 13.1842 7.60485 13.1186 7.49034 13.0041C7.37583 12.8896 7.31023 12.7351 7.30737 12.5732C7.30452 12.4113 7.36462 12.2546 7.47502 12.1361L9.11669 10.4944L7.47502 8.85274C7.35798 8.73555 7.29224 8.5767 7.29224 8.41107C7.29224 8.24545 7.35798 8.08659 7.47502 7.96941Z"
      fill="currentColor"
    />
  </svg>
);
